// extracted by mini-css-extract-plugin
module.exports =  {"container":"_373a3719ba--container--AHU6G","heading":"_373a3719ba--heading--IG_5L","item":"_373a3719ba--item--IBjvE"};